import { createSelector } from 'reselect'
import viewTypes from 'helpers/enums/viewTypes'
import config from 'config'

const uiSelector = state => state.ui

export default createSelector(
	[uiSelector],
	uiData =>
		//WARNING: This won't work if we add standalone activities outside of Google Slides
		//TODO: Make this work for every case of standalone activity
		({
			googleDrivePickerOrigin: [
				viewTypes.STANDALONE_ACTIVITY,
				viewTypes.VIDEO_STANDALONE_CREATE,
				viewTypes.DRAW_IT_STANDALONE_CREATION,
				viewTypes.MATCHING_PAIRS_STANDALONE_CREATION,
				viewTypes.TIME_TO_CLIMB_STANDALONE_CREATION,
			].includes(uiData.currentView)
				? config.googleSlides.origin
				: null,
		})

)
